import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule, ModalController } from '@ionic/angular';

import { DemoAccountService } from 'src/shared/services/demo-account.service';

import { TidyUiComponentsModule } from 'src/tidy-ui-components/tidy-ui-components.module';

/**
 * Small prompt shown when a prospect tries to take an action that isn't allowed in
 * the shared demo account (any write, or a navigation that would land on a page with
 * no demo data). It's purely presentational: "Get Started" dismisses with a result
 * and {@link DemoBlockService} decides where to send the user (the same account-
 * creation flow as the demo banner's "Get Started" button).
 */
@Component({
  selector: 'demo-block-modal',
  templateUrl: './demo-block-modal.component.html',
  styleUrls: ['./demo-block-modal.component.scss'],
  standalone: true,
  imports: [CommonModule, IonicModule, TidyUiComponentsModule],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DemoBlockModalComponent {

  private modalController = inject(ModalController);
  private demoAccountService = inject(DemoAccountService);

  // Default copy adapts to pm-schedule-call-first (Schedule a Call) vs. the default (Create
  // Account). Writable (not readonly) so DemoBlockService can override it via ModalController
  // componentProps — e.g. the new-rental booking gate passes real-account "schedule a call" copy.
  // componentProps are assigned after this field initializer runs, so they win.
  prompt: { title: string; body: string; buttonLabel: string } = this.demoAccountService.demoBlockPrompt();

  getStarted = () => {
    this.modalController.dismiss({ getStarted: true });
  };

  dismiss = () => {
    this.modalController.dismiss();
  };
}
